/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */
import {Pagination} from "./Pagination";


export const BlogList = {
    components: {
        Pagination,
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
    },
    template: `
         <div class="cards" v-if="items">
            <a v-for="(item, index) in items" :key="index" :href="item.url" class="cards__card">
                <div class="cards__card-img">
                    <img class="cards__card-img-picture"
                         :src="item.picture"
                         :alt="item.title">
                  
                </div>
                <h3 class="cards__card-title">
                    {{ item.title }}
                </h3>
                <time
                        class="cards__card-data"
                        :datetime="item.time">
                    {{ item.time }}
                </time>
            </a>
        </div>
        <div v-else style="margin: 56px 0 0;padding-bottom: 70px;">
            Ничего не найдено
        </div>
     
        `,
};
